import * as ngCore from '@angular/core'

/**
 * Inline editable title component for Summit Archive detail
 */
@ngCore.Component({
  imports: [],
  selector: 'atn-detail-title-editor',
  standalone: true,
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** The title to be edited  */
  public valueSg = ngCore.model<string | undefined>(undefined, {
    alias: 'value',
  })

  /** Handle changes to input component */
  public onInputChange(event: Event) {
    if (event.target instanceof HTMLInputElement) {
      const target = event.target
      this.valueSg.set(target.value)
    }
  }
  /** Handle key down events for the input component */
  public onKeyDown(event: KeyboardEvent) {
    if (event.key === 'Enter' && event.target instanceof HTMLInputElement) {
      event.target.blur()
    }
  }
}
